<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
  >
    <v-card
      v-if="drop != null"
    >
      <v-card-title>
        {{ drop.destination.organization.name }} {{ drop.arrival | dateToReadable }}
        <v-spacer/>
        <v-btn
        text
        @click="dialog = false"
        >
          <v-icon>
            fa fa-times
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row
            dense
            v-if="!getPlannerIsLoadingDropTransport"
          >
          <template
            v-if="drop.transports != null"
          >
            <v-col
              v-for="transport in drop.transports"
              cols="12"
              :key="transport.ref"
            >
              <v-card
                color="wrld_subtitle"
                dark
              >
                <v-card-title>
                  Transport Ref: {{ transport.ref }}
                </v-card-title>
                <v-card-subtitle
                  v-if="transport.order != null"
                >
                  Order Ref: {{ transport.order.ref }}
                </v-card-subtitle>
              </v-card>
            </v-col>
          </template>
          <template>
            <v-col
              cols="12"
            >
              <v-card
                color="wrld_subtitle"
                dark
              >
                <v-card-title>
                  {{ $t('orders.empty_drop_transports') }}
                </v-card-title>
              </v-card>
            </v-col>
          </template>
          </v-row>
          <v-row
          v-else
          >
            <v-col
              cols="12"
            >
              <v-card
                flat
              >
                <div class="text-center">
                  <v-progress-circular
                    indeterminate
                    color="wrld_subtitle"
                  ></v-progress-circular>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'DropTransportsInfo',
    props: {
      isOpen: { type: Boolean, default: false },
      dropID: { type: String, default: null }
    },
    data() {
      return {
        dialog: false
      }
    },
    computed: {
      ...mapGetters([
        'getPlannerDropByID',
        'getPlannerIsLoadingDropTransport'
      ]),
      drop () {
        if (this.dropID != null) {
          return this.getPlannerDropByID(this.dropID)
        }
        return null
      }
    },
    watch: {
      isOpen: {
        deep: true,
        immediate: true,
        handler (val) {
          this.dialog = val
        }
      },
      dialog: {
        deep: true,
        immediate: true,
        handler (val) {
          if (!val) {
            this.$emit('close')
          }
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
